import { render, staticRenderFns } from "./side-navigation.vue?vue&type=template&id=1c933738&scoped=true&"
import script from "./side-navigation.vue?vue&type=script&lang=js&"
export * from "./side-navigation.vue?vue&type=script&lang=js&"
import style0 from "./side-navigation.vue?vue&type=style&index=0&id=1c933738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c933738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAppBarNavIcon,VImg,VList,VListGroup,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VNavigationDrawer})
